import React, { useEffect } from 'react'

declare const $

interface Props {
  id: string
  explanation: string
}

const Explanation: React.FC<Props> = ({ id: defaultId, explanation }) => {
  const id = defaultId.replace('.', '_')
  const jqueryId = `#${id}`
  useEffect(() => {
    $(jqueryId).tooltip()

    return () => {
      $(jqueryId).tooltip('dispose')
    }
  }, [id])

  return (
    <span
      id={id}
      className="badge badge-secondary rounded-pill font-weight-normal align-text-bottom ml-1 px-2"
      data-toggle="tooltip"
      data-placement="top"
      title={explanation}
    >
      説明
    </span>
  )
}

export default Explanation
